'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { marketplaceNav } from '@/config/marketplaceNav';
import {
  isMarketplaceNavItemActive,
  marketplaceNavItems,
} from '@/platform/marketplace/marketplaceNavItems';
import { useMarketplaceSellLabel } from '@/platform/marketplace/useMarketplaceSellLabel';
import './marketplace.css';

export function MarketplaceSubNav() {
  const pathname = usePathname() ?? '';
  const sellLabel = useMarketplaceSellLabel();

  if (!marketplaceNav.enabled) return null;

  return (
    <nav className="marketplace-subnav" aria-label="Marketplace">
      {marketplaceNavItems(sellLabel).map((item) => {
        const active = isMarketplaceNavItemActive(item.id, pathname);
        return (
          <Link
            key={item.id}
            href={item.href}
            className={`marketplace-subnav__link${active ? ' marketplace-subnav__link--active' : ''}`}
            aria-current={active ? 'page' : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
